import React, { useRef,  useEffect, useReducer } from 'react';

import { useMenu } from "../../../contexts/MenuContext"

import { IconButton,  Box,  Tabs, Tab, Badge,  Popover } from '@mui/material';

import ChatIcon from '@mui/icons-material/Chat';

import CryptoJS from 'crypto-js';

import InternalChat from '../../InternalChat';

import useNotification from '../../Notification';
import api from '../../../api';
import { isPageVisible } from '../../../utils/isVisible';

import { getSession } from "../../../auth";
import { lockedReducer, funcReducer } from "../../../utils/defaultReducer"
import dayjs from 'dayjs'

import './index.css'

const loadedChats = { '0': true }
const offsets = {'0': 0}
const finished = {}
const limit = 25

const defaultNotificationSettings = {
    new_message: { notification: true, sound: true, silence_after_first: false, visibility: 'always' },
    new_chat: { notification: true, sound: true, visibility: 'always' },
    new_queue: { notification: true, sound: true, visibility: 'always' }
}

const getNotificationConfig = (type) => {
    const settings = getSession()?.profile?.enterprise?.settings || {}
    const notificationSettings = settings.notification_settings || defaultNotificationSettings
    return notificationSettings[type] || defaultNotificationSettings[type]
}

let _internalChatSilenced = false

export let sendInternalChatEvent = () => {}

const loadChat = async (setMessages, teamId) => {
    const user = getSession()
    const enterprise = user?.profile.enterprise
    const enterpriseId = enterprise.id
    const channel = CryptoJS.MD5(enterprise.accountcode).toString()
    const res = await api.get(`/api/enterprises/${enterpriseId}/chat_messages/channel/${channel}/${teamId}/?limit=${limit}&offset=${offsets[teamId] || 0}`)
    if (res.status === 200) {
        if (res.data?.results?.length === 0){
            finished[teamId] = true
            setMessages(oldmessages => ({...oldmessages}))
            return
        }
        setMessages(oldmessages => ({
            ...oldmessages,
            [teamId]: {...(oldmessages[teamId] || {}), ...Object.fromEntries(res.data.results.map(message => ([message.id, message])))} //.toSorted((a, b) => b.timestamp < a.timestamp ? 1 : -1)
        }))
        loadedChats[teamId] = true
        offsets[teamId] = (offsets[teamId] + limit) || limit
    }
}

const InternalChatMenu = () => {

    const user = getSession();

    const { setRealtimeNotification } = useMenu()

    const iconButton = useRef(null);

    const [state, setState] = useReducer(lockedReducer, {
        anchorEl: null,
        socket: null,
        channel: null,
        showCircle: false,
        lastSocketResponse: null,
        my_team: {},
        other_teams: [],
        selectedChat: 0,
        offset:0,
    })

    const [messages, setMessages] = useReducer(funcReducer, {
        0: {}
    })

    const [badges, setBadges] = useReducer(funcReducer, {
    })

    const anchorElRef = useRef(null);
    anchorElRef.current = state.anchorEl;

    const lastSocketResponseRef = useRef(null);
    lastSocketResponseRef.current = state.lastSocketResponse;

    const reAnchor = async () => {
        handleClose();
        await new Promise(r => setTimeout(r, 500))
        handleClick()
    }

    const handleClick = () => {
        setState({ anchorEl: iconButton.current })
        window.setLink = false
        setState({ showCircle: false })
        _internalChatSilenced = false
    };

    const handleClose = () => {
        setState({ anchorEl: null })
    };

    useEffect(() => {
        const resetSilence = () => {
            if (document.visibilityState === 'visible')
                _internalChatSilenced = false
        }
        document.addEventListener('visibilitychange', resetSilence)
        return () => document.removeEventListener('visibilitychange', resetSilence)
    }, [])

    const connectInternalChatSocket = (audio, token) => {
        const hostname = window.location.hostname
        const accountcode = user?.profile.enterprise.accountcode
        const channel = CryptoJS.MD5(accountcode).toString()

        setState({ channel: channel })

        const s = new WebSocket(`wss://${hostname}/chat/ws/chat/${channel}/?token=${token}&notification_user_id=${user?.id}`)

        let keepAlive = null

        s.onopen = (e) => {
            keepAlive = setInterval(() => {
                // If server not responding for more than 30 seconds
                // the connection might have been closed somewhere
                // we need to close and reopen a new websocket connection
                let curTime = new Date().getTime();
                if (state.lastSocketResponseRef && lastSocketResponseRef.current && curTime - lastSocketResponseRef.current > 20000) {
                    s.close()
                    connectInternalChatSocket(audio)
                    return;
                }

                // Pinging server every 20secs
                s.send(JSON.stringify({
                    user: '0',
                    message: 'PING'
                }))
            }, 20000)
        }

        s.onmessage = (e) => {
            const message = JSON.parse(e.data)

            setState({ lastSocketResponse: new Date().getTime() })

            if (message.message == 'PONG')
                return

            if (message.type === "notification") {
                const queues = getSession().profile?.enterprise?.queues || []
                const queue = queues.find(
                    queue => queue.name === message.notification.subtitle
                )
                if (queue)
                    message.notification.subtitle = `Fila: ${queue.description}`
                setRealtimeNotification(message.notification)
                return
            }

            if (message.message == '@UPDATE_TEAM_CHAT'){
                setState({ socket: null })
                return
            }

            message['timestamp'] = dayjs().unix()

            const parsed_team = message.team ? `${message.team}` : '0'

            // TODO: move socket connection and notification handler somewhere else
            if (parsed_team == -1) {
                const urlParams = new URLSearchParams(window.location.search)
                if (urlParams.get("selectedTab") !== "service") {
                    const notificationConfig = getNotificationConfig('new_message')
                    const soundEnabled = notificationConfig.sound !== false
                    const notificationEnabled = notificationConfig.notification !== false
                    const visibility = notificationConfig.visibility || 'always'
                    const visible = isPageVisible()

                    if (notificationConfig.silence_after_first && _internalChatSilenced)
                        return

                    if (visibility === 'other_tabs' && !visible)
                        return
                    if (visibility === 'outside_kwik' && visible)
                        return

                    if (soundEnabled) {
                        audio.play().catch(() => {})
                    }

                    if (notificationEnabled) {
                        if (Notification.permission === "default")
                            Notification.requestPermission()
                        if (Notification.permission === "granted") {
                            const notification = new Notification(message.title, {
                                body: message.message,
                                lang: 'pt-BR',
                                icon: `${window.location.origin}/kwik_favicon.png`,
                                silent: true
                            })
                            notification.addEventListener("click", () => {
                                window.focus()
                                window.location.href = `${window.location.origin}/chat?selectedTab=service`
                            })
                        }
                    }

                    if (notificationConfig.silence_after_first)
                        _internalChatSilenced = true
                }
                return
            }

            if (!anchorElRef || !anchorElRef.current) {
                setState({ showCircle: true })
                const soundEnabled = getNotificationConfig('new_message').sound !== false
                if (soundEnabled) {
                    audio.play().catch(() => {})
                }
            }

            setBadges((oldbadges) => ({ ...oldbadges, [parsed_team]: true }))

            setMessages((oldmessages) => {
                return ({
                    ...oldmessages,
                    [parsed_team]: {...(oldmessages[parsed_team] || {}), [message.id]: message}
                })
            })
        }

        s.onclose = (e) => {
            clearInterval(keepAlive);
            setState({ lastSocketResponse: null })
        }

        setState({ socket: s })
    }

    const sendSocketEvent = (message, team_id) => {
        if(state.socket && state.channel){
            const payload = {
                'channel' : state.channel,
                'message' : message,
                'user'    : `${user.first_name} ${user.last_name}`,
                'team'    : team_id  
            }
            state.socket.send(JSON.stringify(payload))
        }
    }

    const getChatMessages = async () => {
        const enterprise = user?.profile.enterprise
        const enterpriseId = enterprise.id
        const channel = CryptoJS.MD5(enterprise.accountcode).toString()

        const res = await api.get(`/api/enterprises/${enterpriseId}/chat_messages/channel/${channel}/?limit=${limit}&offset=0`)

        if (res.status !== 200) {
            useNotification(
                'Ops!',
                'Não foi possível recuperar as mensagens do chat interno.',
                'danger'
            )
            return
        }

        setMessages({ 0: Object.fromEntries(res.data.results.map(message => ([message.id, message]))) })
        setState({ my_team: res.data.my_team, other_teams: res.data.other_teams })
        offsets[0] = (offsets[0] + limit) || limit

        const audio = new Audio(`${window.location.origin}/new_message.mp3`)
        connectInternalChatSocket(audio, res.data.token)
    }

    useEffect(() => {

        if (!user?.profile.enterprise.has_internal_chat)
            return

        if (!state.socket)
            getChatMessages()

        sendInternalChatEvent = sendSocketEvent

        return () => {
            if (state.socket) {
                state.socket.close()
                setState({ socket: null })
            }
            sendInternalChatEvent = () => {}
        }
    }, [state.socket])

    useEffect(() => {
        if (!(state.selectedChat in loadedChats)) {
            loadChat(setMessages, state.selectedChat)
        }
    }, [state.selectedChat, state.loadedChats])

    useEffect(()=>{
        if (state.selectedChat in badges){
            delete badges[state.selectedChat]
            setBadges({...badges})
        }
    }, [badges, state.selectedChat])

    if (user?.profile.enterprise.has_internal_chat) {
        return (
            <div className="internal-chat-menu-container">
                <IconButton id="internal-chat-icon"
                    ref={iconButton}
                    onClick={handleClick}>
                    <ChatIcon className="toolbar-chat-icon" />
                </IconButton>
                <Popover
                    anchorEl={state.anchorEl}
                    keepMounted
                    sx={{ zIndex: 2001 }}
                    open={Boolean(state.anchorEl)}
                    onClose={handleClose}
                    elevation={0}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'center' }}
                    className="internal-chat-portal-container"
                >
                    <Box className='main-container'>
                        <Tabs className="main-container-tabs" variant="scrollable" scrollButtons="auto" value={state.selectedChat}>
                            {[{ id: 0, name: 'Geral' }, { ...state.my_team, name: "Minha Equipe" }, ...state.other_teams].flatMap(team => {
                                if (!('id' in team)) return
                                return (
                                        <Tab
                                            className={(state.selectedChat === team.id) ? "active" : ""}
                                            onClick={() => setState({ selectedChat: team.id })}
                                            value={team.id}
                                            label={
                                            <Badge className='lower-badge' sx={{padding:'.25rem'}} color="success" variant="dot" invisible={!badges[team.id]}>{team.name}</Badge>
                                            }
                                        />
                                )
                            })}
                        </Tabs>
                    </Box>
                    <InternalChat
                        key={`internal-chat-main-${state.selectedChat}`}
                        reAnchor={() => reAnchor()}
                        handleClose={() => handleClose()}
                        socket={state.socket}
                        channel={state.channel}
                        messages={messages[state.selectedChat] || {}}
                        teamId={state.selectedChat}
                        loadMore={() => loadChat(setMessages, state.selectedChat)}
                        finished={finished[state.selectedChat]}
                    />
                </Popover>
                {state.showCircle &&
                    <Box className="notification-circle"></Box>
                }
            </div>
        );
    } else {
        return (
            <></>
        );
    }
}

export default InternalChatMenu;
